import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=e558e51e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=e558e51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e558e51e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e558e51e')) {
      api.createRecord('e558e51e', component.options)
    } else {
      api.reload('e558e51e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=e558e51e&scoped=true&", function () {
      api.rerender('e558e51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B7nb7XzZl3UY/JS/comp/DocBox.vue"
export default component.exports